module.exports = __webpack_public_path__ + "img/cmfri.d2e4f9f5.jpg";